<template>
<el-form-item>
  <el-radio-group v-model="model.trjtype" size="small" @change="onHySplitTypeChange">
    <el-radio
      v-for="hySplitType in hySplitTypes"
      :key="hySplitType.value"
      :label="hySplitType.value"
    >{{hySplitType.label}}</el-radio>
  </el-radio-group>
</el-form-item>
</template>

<script>
import Option from './Option'

import BaseHySplit from './BaseHySplit'

const {hySplitTypes} = Option

export default {
  name: 'HySplitTypeSelector',
  extends: BaseHySplit,
  computed: {
    hySplitTypes: () => hySplitTypes
  },
  methods: {
    onHySplitTypeChange (hySplitTypeValue) {
      this.$emit('change', hySplitTypeValue)
    }
  },
  created () {
    this.onHySplitTypeChange(this.model.trjtype = hySplitTypes[0].value)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/HySplitTypeSelector.vue